module.exports = require("original-fs");